// extracted by mini-css-extract-plugin
export var createdDate = "_lq-1";
export var divider = "_lq-2";
export var headerDivider = "_lq-3";
export var messagesCard = "_lq-0";
export var messagesContainer = "_lq-7";
export var messagesContainerWrapper = "_lq-4";
export var pointerCapturingButtonBoxes = "_lq-a";
export var showLeftPanelButton = "_lq-9";
export var showMoreButton = "_lq-c";
export var showMoreButtonContainer = "_lq-b";
export var summaryTitle = "_lq-6";
export var systemMessageCardWrapper = "_lq-d";
export var topButtons = "_lq-8";
export var withPadding = "_lq-5";